import "autocompleter";

(function ($) {
	$(function () {
		let cache = {};
		let container = document.createElement("div");
		let $container = $(container);
		let $loading = $('<svg class="autocomplete__loading" xmlns="http://www.w3.org/2000/svg" width="80" height="80" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100">\n' +
			'    <circle cx="50" cy="50" r="30" fill="none" stroke="#D2D2D2" stroke-width="4"/>\n' +
			'    <circle cx="50" cy="50" r="30" fill="none" stroke="#04009F" stroke-width="4">\n' +
			'        <animateTransform attributeName="transform" dur="2s" keyTimes="0;0.5;1" repeatCount="indefinite" type="rotate" values="0 50 50;180 50 50;720 50 50"/>\n' +
			'        <animate attributeName="stroke-dasharray" dur="2s" keyTimes="0;0.5;1" repeatCount="indefinite" values="75 169.65;150 150;75 169.65"/>\n' +
			'    </circle>\n' +
			'</svg>');
		let mobileAutocomplete;
		$('.navigation__search-open').on('click', function () {
			$('.navigation__search--mobile').addClass('open').find('input').focus();
			$('html').addClass('search_overflow');
			if (mobileAutocomplete) {
				mobileAutocomplete.fetch();
			}
		})
		$('.navigation__search-close').on('click', function () {
			$('.navigation__search--mobile').removeClass('open');
			$('html').removeClass('search_overflow');
		})
		$(".navigation__search-input").each(function () {
			let input = this;
			let $input = $(this);

			function initAutocomplete() {

				let $form = $input.closest('form');
				let block_submit = false;
				let last_ajax;
				let $wrap = $input.closest('.nav__search');
				let isMobile = true;
				let $desktop_search = $('.navigation__search--desktop');
				isMobile = true;

				function returnAutoload(mutationList, observer) {
					if (!mobileAutocomplete) {
						return;
					}
					for (const mutation of mutationList) {
						if (mutation.type === "childList") {
							if ($container.parent().get(0) !== $wrap.get(0)) {
								$wrap.append($container);
							}
						}
					}
				}

				if ($wrap.hasClass('navigation__search--desktop')) {
					isMobile = false;
					$wrap = $form;
				} else {

					// this will return autoload results back after being returned
					const observer = new MutationObserver(returnAutoload);
					observer.observe($wrap.get(0), {childList: true});
				}
				$form.on('submit', function (e) {
					if (block_submit) {
						e.preventDefault();
					}
				})

				$input.on('focus', function () {
					$wrap.append($container);
				});
				let $window = $(window);
				let maybe_keep_open = isMobile ? function () {
					$wrap.append($container);
				} : function () {
				};

				function update_autocomplete() {
					return autocomplete({
						input: input,
						minLength: 0,
						disableAutoSelect: true,
						container: container,
						emptyMsg: "Žádné výsledky",
						debounceWaitMs: 200,
						showOnFocus: true,
						className: 'search_result',
						customize: function (input, inputRect, container, maxHeight) {
							container.style.top = '';
							container.style.left = '';
							container.style.width = '';
							container.style.maxHeight = ($window.height() - container.getBoundingClientRect().top) + 'px';
						},
						renderGroup: function (groupName, currentValue) {
							let $group = $('<div class="search_result-title">' + groupName + '</div>');
							return $group.get(0);
						},
						render: function (item, currentValue) {
							return $(item.html).get(0);
						},
						fetch: function (text, update) {
							block_submit = false;
							var term = text.toLowerCase();

							if (term in cache) {
								update(cache[term]);
								return;
							}
							$wrap.append($container);
							$container.html($loading);

							let current_ajax = last_ajax = gp_ajax({
								url: ghostpress_params.ajax_url,
								type: "get",
								dataType: 'json',
								data: {
									action: 'autocomplete',
									search: term,
								}
							}).done(function (response, textStatus, jqXHR) {
								cache[term] = response.data.search_result;
								if (last_ajax === current_ajax) {
									update(response.data.search_result);
								}
							}).fail(function (response) {
								if (last_ajax === current_ajax) {
									update([]);
								}
							});
						},
					})
				}

				let autocomplete_instance;

				function update() {
					if ($desktop_search.is(':visible')) {
						if (isMobile) {
							if (autocomplete_instance) {
								autocomplete_instance.destroy();
								autocomplete_instance = null;
								mobileAutocomplete = autocomplete_instance;
							}
						} else {
							if (!autocomplete_instance) {
								autocomplete_instance = update_autocomplete();
								mobileAutocomplete = autocomplete_instance;
							}
						}
					} else {
						if (isMobile) {
							if (!autocomplete_instance) {
								autocomplete_instance = update_autocomplete();
								mobileAutocomplete = autocomplete_instance;
								if ($input.is(':visible')) {
									autocomplete_instance.fetch();
								}
							}
						} else {
							if (autocomplete_instance) {
								autocomplete_instance.destroy();
								autocomplete_instance = null;
							}
						}
					}
				}

				update();
				window.addEventListener('resize', update, {passive: true});
			}

			setTimeout(initAutocomplete);

			return

		});


	});
})(jQuery);